module.exports = __webpack_public_path__ + "images/district_back.1792157180594.png";